// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
export var FormType;
(function (FormType) {
    FormType["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
    FormType["TYPE_FORM"] = "TYPE_FORM";
    FormType["TYPE_PACKET"] = "TYPE_PACKET";
})(FormType || (FormType = {}));
export var FormType_index;
(function (FormType_index) {
    FormType_index[FormType_index["TYPE_UNKNOWN"] = 0] = "TYPE_UNKNOWN";
    FormType_index[FormType_index["TYPE_FORM"] = 1] = "TYPE_FORM";
    FormType_index[FormType_index["TYPE_PACKET"] = 2] = "TYPE_PACKET";
})(FormType_index || (FormType_index = {}));
export var SubmissionMode;
(function (SubmissionMode) {
    SubmissionMode["SUBMISSION_MODE_UNKNOWN"] = "SUBMISSION_MODE_UNKNOWN";
    SubmissionMode["SOLICITED_AUTOREMINDER"] = "SOLICITED_AUTOREMINDER";
    SubmissionMode["SOLICITED_DESKTOPCLIENT"] = "SOLICITED_DESKTOPCLIENT";
    SubmissionMode["SOLICITED_INCHAIRKIOSK"] = "SOLICITED_INCHAIRKIOSK";
    SubmissionMode["UNSOLICITED_PUBLICLINKS"] = "UNSOLICITED_PUBLICLINKS";
    SubmissionMode["UNSOLICITED_PATIENTKIOSK"] = "UNSOLICITED_PATIENTKIOSK";
    SubmissionMode["SOLICITED_DIRECT"] = "SOLICITED_DIRECT";
    SubmissionMode["SOLICITED_OFFICEKIOSK"] = "SOLICITED_OFFICEKIOSK";
    SubmissionMode["SOLICITED_MOBILECLIENT"] = "SOLICITED_MOBILECLIENT";
})(SubmissionMode || (SubmissionMode = {}));
export var SubmissionMode_index;
(function (SubmissionMode_index) {
    SubmissionMode_index[SubmissionMode_index["SUBMISSION_MODE_UNKNOWN"] = 0] = "SUBMISSION_MODE_UNKNOWN";
    SubmissionMode_index[SubmissionMode_index["SOLICITED_AUTOREMINDER"] = 1] = "SOLICITED_AUTOREMINDER";
    SubmissionMode_index[SubmissionMode_index["SOLICITED_DESKTOPCLIENT"] = 2] = "SOLICITED_DESKTOPCLIENT";
    SubmissionMode_index[SubmissionMode_index["SOLICITED_INCHAIRKIOSK"] = 3] = "SOLICITED_INCHAIRKIOSK";
    SubmissionMode_index[SubmissionMode_index["UNSOLICITED_PUBLICLINKS"] = 4] = "UNSOLICITED_PUBLICLINKS";
    SubmissionMode_index[SubmissionMode_index["UNSOLICITED_PATIENTKIOSK"] = 5] = "UNSOLICITED_PATIENTKIOSK";
    SubmissionMode_index[SubmissionMode_index["SOLICITED_DIRECT"] = 6] = "SOLICITED_DIRECT";
    SubmissionMode_index[SubmissionMode_index["SOLICITED_OFFICEKIOSK"] = 7] = "SOLICITED_OFFICEKIOSK";
    SubmissionMode_index[SubmissionMode_index["SOLICITED_MOBILECLIENT"] = 8] = "SOLICITED_MOBILECLIENT";
})(SubmissionMode_index || (SubmissionMode_index = {}));
export var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["UNSPECIFIED"] = "UNSPECIFIED";
    ReviewStatus["APPROVED"] = "APPROVED";
    ReviewStatus["REJECTED"] = "REJECTED";
})(ReviewStatus || (ReviewStatus = {}));
export var ReviewStatus_index;
(function (ReviewStatus_index) {
    ReviewStatus_index[ReviewStatus_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ReviewStatus_index[ReviewStatus_index["APPROVED"] = 1] = "APPROVED";
    ReviewStatus_index[ReviewStatus_index["REJECTED"] = 2] = "REJECTED";
})(ReviewStatus_index || (ReviewStatus_index = {}));
export var BIReport;
(function (BIReport) {
    BIReport["BI_REPORT_UNSPECIFIED"] = "BI_REPORT_UNSPECIFIED";
    BIReport["BI_REPORT_FORMSUBMISSIONS"] = "BI_REPORT_FORMSUBMISSIONS";
})(BIReport || (BIReport = {}));
export var BIReport_index;
(function (BIReport_index) {
    BIReport_index[BIReport_index["BI_REPORT_UNSPECIFIED"] = 0] = "BI_REPORT_UNSPECIFIED";
    BIReport_index[BIReport_index["BI_REPORT_FORMSUBMISSIONS"] = 1] = "BI_REPORT_FORMSUBMISSIONS";
})(BIReport_index || (BIReport_index = {}));
export var DashboardLabel;
(function (DashboardLabel) {
    DashboardLabel["DASHBOARD_LABEL_UNKNOWN"] = "DASHBOARD_LABEL_UNKNOWN";
    DashboardLabel["DASHBOARD_LABEL_INBOX"] = "DASHBOARD_LABEL_INBOX";
    DashboardLabel["DASHBOARD_LABEL_RECENT"] = "DASHBOARD_LABEL_RECENT";
    DashboardLabel["DASHBOARD_LABEL_NEEDS_REVIEW"] = "DASHBOARD_LABEL_NEEDS_REVIEW";
    DashboardLabel["DASHBOARD_LABEL_SYNC_MANUALLY"] = "DASHBOARD_LABEL_SYNC_MANUALLY";
    DashboardLabel["DASHBOARD_LABEL_MANUAL"] = "DASHBOARD_LABEL_MANUAL";
    DashboardLabel["DASHBOARD_LABEL_PENDING"] = "DASHBOARD_LABEL_PENDING";
    DashboardLabel["DASHBOARD_LABEL_RETRY_SYNC"] = "DASHBOARD_LABEL_RETRY_SYNC";
    DashboardLabel["DASHBOARD_LABEL_REVIEWED"] = "DASHBOARD_LABEL_REVIEWED";
    DashboardLabel["DASHBOARD_LABEL_APPROVED"] = "DASHBOARD_LABEL_APPROVED";
    DashboardLabel["DASHBOARD_LABEL_REJECTED"] = "DASHBOARD_LABEL_REJECTED";
    DashboardLabel["DASHBOARD_LABEL_COMPLETED"] = "DASHBOARD_LABEL_COMPLETED";
    DashboardLabel["DASHBOARD_LABEL_COMPLETED_WITH_WRITEBACKS"] = "DASHBOARD_LABEL_COMPLETED_WITH_WRITEBACKS";
    DashboardLabel["DASHBOARD_LABEL_COMPLETED_WITHOUT_WRITEBACKS"] = "DASHBOARD_LABEL_COMPLETED_WITHOUT_WRITEBACKS";
    DashboardLabel["DASHBOARD_LABEL_SENT"] = "DASHBOARD_LABEL_SENT";
    DashboardLabel["DASHBOARD_LABEL_ARCHIVED"] = "DASHBOARD_LABEL_ARCHIVED";
})(DashboardLabel || (DashboardLabel = {}));
export var DashboardLabel_index;
(function (DashboardLabel_index) {
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_UNKNOWN"] = 0] = "DASHBOARD_LABEL_UNKNOWN";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_INBOX"] = 1] = "DASHBOARD_LABEL_INBOX";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_RECENT"] = 2] = "DASHBOARD_LABEL_RECENT";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_NEEDS_REVIEW"] = 3] = "DASHBOARD_LABEL_NEEDS_REVIEW";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_SYNC_MANUALLY"] = 4] = "DASHBOARD_LABEL_SYNC_MANUALLY";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_MANUAL"] = 5] = "DASHBOARD_LABEL_MANUAL";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_PENDING"] = 6] = "DASHBOARD_LABEL_PENDING";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_RETRY_SYNC"] = 7] = "DASHBOARD_LABEL_RETRY_SYNC";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_REVIEWED"] = 8] = "DASHBOARD_LABEL_REVIEWED";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_APPROVED"] = 9] = "DASHBOARD_LABEL_APPROVED";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_REJECTED"] = 10] = "DASHBOARD_LABEL_REJECTED";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_COMPLETED"] = 11] = "DASHBOARD_LABEL_COMPLETED";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_COMPLETED_WITH_WRITEBACKS"] = 12] = "DASHBOARD_LABEL_COMPLETED_WITH_WRITEBACKS";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_COMPLETED_WITHOUT_WRITEBACKS"] = 13] = "DASHBOARD_LABEL_COMPLETED_WITHOUT_WRITEBACKS";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_SENT"] = 14] = "DASHBOARD_LABEL_SENT";
    DashboardLabel_index[DashboardLabel_index["DASHBOARD_LABEL_ARCHIVED"] = 15] = "DASHBOARD_LABEL_ARCHIVED";
})(DashboardLabel_index || (DashboardLabel_index = {}));
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus["LISTING_STATUS_UNSPECIFIED"] = "LISTING_STATUS_UNSPECIFIED";
    ListingStatus["PINNED"] = "PINNED";
    ListingStatus["DEFAULT"] = "DEFAULT";
    ListingStatus["HIDDEN"] = "HIDDEN";
})(ListingStatus || (ListingStatus = {}));
export var ListingStatus_index;
(function (ListingStatus_index) {
    ListingStatus_index[ListingStatus_index["LISTING_STATUS_UNSPECIFIED"] = 0] = "LISTING_STATUS_UNSPECIFIED";
    ListingStatus_index[ListingStatus_index["PINNED"] = 1] = "PINNED";
    ListingStatus_index[ListingStatus_index["DEFAULT"] = 2] = "DEFAULT";
    ListingStatus_index[ListingStatus_index["HIDDEN"] = 3] = "HIDDEN";
})(ListingStatus_index || (ListingStatus_index = {}));
export var KioskModeOrderBy;
(function (KioskModeOrderBy) {
    KioskModeOrderBy["KIOSK_MODE_ORDER_BY_UNSPECIFIED"] = "KIOSK_MODE_ORDER_BY_UNSPECIFIED";
    KioskModeOrderBy["ALPHABETICAL"] = "ALPHABETICAL";
    KioskModeOrderBy["CREATED_AT"] = "CREATED_AT";
    KioskModeOrderBy["LAST_MODIFIED_AT"] = "LAST_MODIFIED_AT";
    KioskModeOrderBy["RECENTLY_USED"] = "RECENTLY_USED";
})(KioskModeOrderBy || (KioskModeOrderBy = {}));
export var KioskModeOrderBy_index;
(function (KioskModeOrderBy_index) {
    KioskModeOrderBy_index[KioskModeOrderBy_index["KIOSK_MODE_ORDER_BY_UNSPECIFIED"] = 0] = "KIOSK_MODE_ORDER_BY_UNSPECIFIED";
    KioskModeOrderBy_index[KioskModeOrderBy_index["ALPHABETICAL"] = 1] = "ALPHABETICAL";
    KioskModeOrderBy_index[KioskModeOrderBy_index["CREATED_AT"] = 2] = "CREATED_AT";
    KioskModeOrderBy_index[KioskModeOrderBy_index["LAST_MODIFIED_AT"] = 3] = "LAST_MODIFIED_AT";
    KioskModeOrderBy_index[KioskModeOrderBy_index["RECENTLY_USED"] = 4] = "RECENTLY_USED";
})(KioskModeOrderBy_index || (KioskModeOrderBy_index = {}));
export var KioskListSourceType;
(function (KioskListSourceType) {
    KioskListSourceType["KIOSK"] = "KIOSK";
    KioskListSourceType["OFFICE"] = "OFFICE";
})(KioskListSourceType || (KioskListSourceType = {}));
export var KioskListSourceType_index;
(function (KioskListSourceType_index) {
    KioskListSourceType_index[KioskListSourceType_index["KIOSK"] = 0] = "KIOSK";
    KioskListSourceType_index[KioskListSourceType_index["OFFICE"] = 1] = "OFFICE";
})(KioskListSourceType_index || (KioskListSourceType_index = {}));
export var StatsType;
(function (StatsType) {
    StatsType["WIDGET_NAME_UNSPECIFIED"] = "WIDGET_NAME_UNSPECIFIED";
    StatsType["BRIEF_TOTAL_FORM_SENT"] = "BRIEF_TOTAL_FORM_SENT";
    StatsType["BRIEF_TOTAL_FORM_SUBMISSION"] = "BRIEF_TOTAL_FORM_SUBMISSION";
    StatsType["CONCISE_TOTAL_FORM_SENT"] = "CONCISE_TOTAL_FORM_SENT";
    StatsType["CONCISE_TOTAL_FORM_SUBMISSION"] = "CONCISE_TOTAL_FORM_SUBMISSION";
    StatsType["COMPREHENSIVE_TOTAL_FORM_SENT"] = "COMPREHENSIVE_TOTAL_FORM_SENT";
    StatsType["COMPREHENSIVE_TOTAL_FORM_SUBMISSION"] = "COMPREHENSIVE_TOTAL_FORM_SUBMISSION";
})(StatsType || (StatsType = {}));
export var StatsType_index;
(function (StatsType_index) {
    StatsType_index[StatsType_index["WIDGET_NAME_UNSPECIFIED"] = 0] = "WIDGET_NAME_UNSPECIFIED";
    StatsType_index[StatsType_index["BRIEF_TOTAL_FORM_SENT"] = 1] = "BRIEF_TOTAL_FORM_SENT";
    StatsType_index[StatsType_index["BRIEF_TOTAL_FORM_SUBMISSION"] = 2] = "BRIEF_TOTAL_FORM_SUBMISSION";
    StatsType_index[StatsType_index["CONCISE_TOTAL_FORM_SENT"] = 3] = "CONCISE_TOTAL_FORM_SENT";
    StatsType_index[StatsType_index["CONCISE_TOTAL_FORM_SUBMISSION"] = 4] = "CONCISE_TOTAL_FORM_SUBMISSION";
    StatsType_index[StatsType_index["COMPREHENSIVE_TOTAL_FORM_SENT"] = 5] = "COMPREHENSIVE_TOTAL_FORM_SENT";
    StatsType_index[StatsType_index["COMPREHENSIVE_TOTAL_FORM_SUBMISSION"] = 6] = "COMPREHENSIVE_TOTAL_FORM_SUBMISSION";
})(StatsType_index || (StatsType_index = {}));
export const WFormsAPI = {
    /**
     * Deprecated: Use GetForms instead
     */
    GetFormList(fn, req) {
        return fn(`/forms-digital/v1/forms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use GetPacketsV3 instead
     */
    GetPacketList(fn, req) {
        return fn(`/forms-digital/v1/packets?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateFormsLink(fn, req) {
        return fn(`/forms-digital/v1/create-form-links`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    AddCompany(fn, req) {
        return fn(`/forms-digital/v1/companies`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SetFormSubmitFlag(fn, req) {
        return fn(`/forms-digital/v1/companies/forms-submitted`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    GetFormSubmitFlag(fn, req) {
        try {
            fm.validateUrlParam(req["companyId"], "companyId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/companies/forms-submitted/${req["companyId"]}?${fm.renderURLSearchParams(req, ["companyId"])}`, { method: "GET" });
    },
    SubmitForm(fn, req) {
        return fn(`/forms-digital/v1/submit-form`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated: Use CreatePacketV2 instead
     */
    CreatePacket(fn, req) {
        try {
            fm.validateUrlParam(req["companyId"], "companyId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/companies/${req["companyId"]}/packets`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated: Use GetPacketsV3 instead
     */
    GetPacket(fn, req) {
        try {
            fm.validateUrlParam(req["companyId"], "companyId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/companies/${req["companyId"]}/packets?${fm.renderURLSearchParams(req, ["companyId"])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use UpdatePacketV2 instead
     */
    UpdatePacket(fn, req) {
        try {
            fm.validateUrlParam(req["companyId"], "companyId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/companies/${req["companyId"]}/packets`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated: Use DeletePacketV2 instead
     */
    DeletePacket(fn, req) {
        try {
            fm.validateUrlParam(req["companyId"], "companyId");
            fm.validateUrlParam(req["packetId"], "packetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/companies/${req["companyId"]}/packets/${req["packetId"]}?${fm.renderURLSearchParams(req, ["companyId", "packetId"])}`, { method: "DELETE" });
    },
    GetFormsKiosk(fn, req) {
        return fn(`/forms-digital/v1/kiosk/forms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetPacketsKiosk(fn, req) {
        return fn(`/forms-digital/v1/kiosk/packets?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateKioskListingStatus(fn, req) {
        return fn(`/forms-digital/v1/kiosk/listing-status`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateWritebackSettings(fn, req) {
        try {
            fm.validateUrlParam(req["settingId"], "settingId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/writeback/settings/${req["settingId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * This API is used to update the writeback settings for multiple locations
     */
    UpdateLocationsWritebackSettings(fn, req) {
        return fn(`/forms-digital/v2/writeback/settings`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetWritebackSettings(fn, req) {
        return fn(`/forms-digital/v1/writeback/settings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use CreateFormV2 or UpdateFormV2 instead for create or update respecively
     */
    UpsertForm(fn, req) {
        return fn(`/forms-digital/v1/forms`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated: Use DeleteFormV2 instead
     */
    DeleteForm(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/forms/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    GetLegalTerms(fn, req) {
        return fn(`/forms-digital/v1/legal?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateLegalTerms(fn, req) {
        return fn(`/forms-digital/v1/legal`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * This API is used to update the legal terms for multiple locations
     */
    UpdateLocationsLegalTerms(fn, req) {
        return fn(`/forms-digital/v2/legal`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetLogo(fn, req) {
        return fn(`/forms-digital/v1/company/logo?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    DeleteLogo(fn, req) {
        return fn(`/forms-digital/v1/company/logo?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    GetAuditLogs(fn, req) {
        return fn(`/forms-digital/v1/company/audit-logs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    AddAuditLog(fn, req) {
        return fn(`/forms-digital/v1/company/audit-logs`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCompanyConfig(fn, req) {
        return fn(`/forms-digital/v1/company/config`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated: Use GetSubmissionsV2 instead
     */
    GetSubmissions(fn, req) {
        return fn(`/forms-digital/v1/submissions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetSubmissionsV2(fn, req) {
        return fn(`/forms-digital/v2/submissions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetSubmissionsById(fn, req) {
        try {
            fm.validateUrlParam(req["submissionId"], "submissionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/submissions/${req["submissionId"]}?${fm.renderURLSearchParams(req, ["submissionId"])}`, { method: "GET" });
    },
    GetFormTemplate(fn, req) {
        return fn(`/forms-digital/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use GetFormsV3 instead
     */
    GetFormListInternal(fn, req) {
        return fn(`/forms-digital/v1/forms-internal?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use GetFormsV3 instead
     */
    GetForms(fn, req) {
        return fn(`/forms-digital/v2/forms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use GetPacketsV3 instead
     */
    GetPackets(fn, req) {
        return fn(`/forms-digital/v2/packets?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetFormPDF(fn, req) {
        return fn(`/forms-digital/v1/pdf?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetFormElements(fn, req) {
        return fn(`/forms-digital/v1/form-elements?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetSupportedPMSList(fn, req) {
        return fn(`/forms-digital/v1/supported-pms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SyncPMSMedicalConditions(fn, req) {
        try {
            fm.validateUrlParam(req["conditionName"], "conditionName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/medical-conditions/${req["conditionName"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetPMSMedicalConditions(fn, req) {
        return fn(`/forms-digital/v1/medical-conditions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SearchPatientForKiosk(fn, req) {
        return fn(`/forms-digital/v1/patient-search`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SearchCustomUser(fn, req) {
        return fn(`/forms-digital/v1/search-custom-user`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateWritebackAuthStatus(fn, req) {
        return fn(`/forms-digital/v1/writeback/auth/status`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetWritebackAuthStatus(fn, req) {
        return fn(`/forms-digital/v1/writeback/auth/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * This API returns total unread submissions count for different navigation/category.
     */
    GetSubmissionSummaryByCompanyId(fn, req) {
        try {
            fm.validateUrlParam(req["companyId"], "companyId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/company/${req["companyId"]}/submission/stats?${fm.renderURLSearchParams(req, ["companyId"])}`, { method: "GET" });
    },
    GetCategoryCountByCompanyId(fn, req) {
        try {
            fm.validateUrlParam(req["companyId"], "companyId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/company/${req["companyId"]}/submission/category/stats?${fm.renderURLSearchParams(req, ["companyId"])}`, { method: "GET" });
    },
    /**
     * This is a single API for all the office to get the writeback capability
     * API only includes sources that are writeback capable
     */
    GetWritebackCapabilitiesV3(fn, req) {
        return fn(`/forms-digital/v3/writeback-capabilities?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Returns true if any source integrated with location is writeback capable.
     * This API helps display submission tabs if a location is writeback capable.
     * Deprecated, use "/v3/writeaback-capabilities"
     */
    CheckLocationWritebackCapability(fn, req) {
        return fn(`/forms-digital/v1/location-writeback-capability?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CheckLocationHasMultipleSyncApps(fn, req) {
        return fn(`/forms-digital/v1/locations/multiple-syncapp?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SourceTenants(fn, req) {
        return fn(`/forms-digital/v1/locations/source-tenants?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use GetStatesV2 instead
     */
    GetStates(fn, req) {
        return fn(`/forms-digital/v1/states?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetStatesV2(fn, req) {
        return fn(`/forms-digital/v2/states?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    OnboardCompany(fn, req) {
        return fn(`/forms-digital/v1/onboard-company`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    MedicalHistoryAnswerOptionsToggle(fn, req) {
        return fn(`/forms-digital/v1/toggle-medical-conditions`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated: Use GetForms instead
     */
    GetFormTemplates(fn, req) {
        return fn(`/forms-digital/v1/list-templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetUnreadSubmissionCount(fn, req) {
        return fn(`/forms-digital/v1/submissions/unread-count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateSubmissionIsRead(fn, req) {
        return fn(`/forms-digital/v1/submissions/update-is-read`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated
     */
    GetWritebackStatusPMSDetails(fn, req) {
        return fn(`/forms-digital/v1/writeback-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use UpdateSubmissionsArchiveStatusV2 instead
     */
    UpdateArchiveStatusForSubmissions(fn, req) {
        return fn(`/forms-digital/v1/submissions-archive-status`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    CopyFormsToTargetCompanies(fn, req) {
        return fn(`/forms-digital/v1/copy-forms`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated - Use SetPreferredSourceTenant instead.
     */
    UpdatePreferredSyncApp(fn, req) {
        return fn(`/forms-digital/v1/preferred-sync-app`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Deprecated - Use GetPreferredSourceTenant instead.
     */
    GetPreferredSyncApp(fn, req) {
        return fn(`/forms-digital/v1/preferred-sync-app?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetPreferredSourceTenant(fn, req) {
        return fn(`/forms-digital/v1/preferred-source-tenant?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SetPreferredSourceTenant(fn, req) {
        return fn(`/forms-digital/v1/preferred-source-tenant`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    GetTemplateBody(fn, req) {
        return fn(`/forms-digital/v1/template-body?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    DeleteTemplate(fn, req) {
        return fn(`/forms-digital/v1/templates?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * Deprecated: Use CreateFormUsingTemplateForOrg instead
     */
    CreateFormUsingTemplate(fn, req) {
        return fn(`/forms-digital/v1/copy-template-to-form`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateFormUsingTemplateForOrg(fn, req) {
        return fn(`/forms-digital/v2/copy-template-to-form`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    MarkTemplateFavourite(fn, req) {
        return fn(`/forms-digital/v1/mark-template-favourite`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    GetTemplates(fn, req) {
        return fn(`/forms-digital/v1/templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetFilters(fn, req) {
        return fn(`/forms-digital/v1/templates/filters?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateTemplateThumbnail(fn, req) {
        return fn(`/forms-digital/v1/template-thumbnail`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateTemplateTermsConditionsStatus(fn, req) {
        return fn(`/forms-digital/v1/template/terms-conditions`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    GetTemplateTermsConditionsStatus(fn, req) {
        return fn(`/forms-digital/v1/template/terms-conditions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     *Update 'review_required' flag of the form.
     */
    UpdateFormReviewRequiredFlag(fn, req) {
        return fn(`/forms-digital/v1/forms/review-required`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Update 'review_required' flag of the packet.
     */
    UpdatePacketReviewRequiredFlag(fn, req) {
        return fn(`/forms-digital/v1/packets/review-required`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Deprecated: Use UpsertProvidersMapping instead.
     *Create provider-weave user mapping.
     */
    MapProviderAndWUser(fn, req) {
        return fn(`/forms-digital/v1/providers/weave-user-mapping`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Deprecated: Use UpsertProvidersMapping instead.
     *Update provider-weave-user mapping.
     */
    UpdateProviderAndWUserMapping(fn, req) {
        return fn(`/forms-digital/v1/providers/weave-user-mapping`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Deprecated: Use DeleteProvidersMapping instead.
     *Delete provider-user mapping.
     */
    DeleteProviderMapping(fn, req) {
        return fn(`/forms-digital/v1/providers/weave-user-mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     *Upsert provider and weave user mappings
     */
    UpsertProvidersMapping(fn, req) {
        return fn(`/forms-digital/v2/providers/weave-user-mapping`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Delete provider and weave user mappings
     */
    DeleteProvidersMapping(fn, req) {
        return fn(`/forms-digital/v2/providers/weave-user-mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     *Get provider-user mapping.
     */
    GetProviderMappings(fn, req) {
        return fn(`/forms-digital/v1/providers/weave-user-mapping?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     *Adds provider's review to the submission
     */
    AddProviderReview(fn, req) {
        return fn(`/forms-digital/v1/provider-review`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Update provider details by submissionID
     */
    UpdateProviderDetailsBySubmissionID(fn, req) {
        return fn(`/forms-digital/v1/provider-details`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Get providers for given company.
     */
    GetProviders(fn, req) {
        return fn(`/forms-digital/v1/providers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Save default e-sign for provider
     */
    UpdateProviderEsign(fn, req) {
        return fn(`/forms-digital/v1/provider-esign`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Get default e-sign for provider.
     */
    GetProviderEsign(fn, req) {
        return fn(`/forms-digital/v1/provider-esign?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Add custom user feature access
     */
    AddCustomUser(fn, req) {
        return fn(`/forms-digital/v1/custom-user`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Delete custom user feature access
     */
    DeleteCustomUser(fn, req) {
        return fn(`/forms-digital/v1/custom-user?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * Send FormReportingBI data - for testing purpose
     */
    PushFormsBIReport(fn, req) {
        return fn(`/forms-digital/v1/bi-report`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Download form PDF for authenticated users
     */
    GetFormPDFAuthed(fn, req) {
        return fn(`/forms-digital/v1/pdf-auth?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: In the new experience, we don't sync individual form.
     * Fetch ES medical history form by id for sync
     */
    GetESMedicalHistoryForm(fn, req) {
        return fn(`/forms-digital/v1/es-medical-history-form?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Fetches ES medical history forms for import
     */
    GetESMedicalHistoryForms(fn, req) {
        return fn(`/forms-digital/v1/es-medical-history-forms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     *Insert ES Medical history forms
     *Deprecated: Use InsertESMedicalHistoryFormsV2 instead
     */
    InsertESMedicalHistoryForms(fn, req) {
        return fn(`/forms-digital/v1/es-medical-history-forms`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    SendOTP(fn, req) {
        return fn(`/forms-digital/v1/prepopulation/otp`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetAnalyticsStats(fn, req) {
        return fn(`/forms-digital/v1/analytics/stats?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * This API is used to fetch all the form digitization process details
     */
    GetUploadedFormsDetails(fn, req) {
        return fn(`/forms-digital/v1/digitization/process?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * This API is used to update the form digitization process Fees check
     */
    UpdateDigitizationFeesCheck(fn, req) {
        return fn(`/forms-digital/v1/digitization/fees-check`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * This is used to fetch the form digitization process configuration
     */
    GetDigitizationFeesCheck(fn, req) {
        return fn(`/forms-digital/v1/digitization/fees-check?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    RefreshSourceTenants(fn, req) {
        return fn(`/forms-digital/v1/refresh-source-tenants`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    IsFeatureFlagOn(fn, req) {
        return fn(`/forms-digital/v1/feature-flag?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateFormV2(fn, req) {
        return fn(`/forms-digital/v2/forms`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateFormV2(fn, req) {
        return fn(`/forms-digital/v2/forms`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteFormV2(fn, req) {
        try {
            fm.validateUrlParam(req["formId"], "formId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v2/forms/${req["formId"]}?${fm.renderURLSearchParams(req, ["formId"])}`, { method: "DELETE" });
    },
    GetFormsV3(fn, req) {
        return fn(`/forms-digital/v3/forms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreatePacketV2(fn, req) {
        return fn(`/forms-digital/v2/packets`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdatePacketV2(fn, req) {
        return fn(`/forms-digital/v2/packets`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeletePacketV2(fn, req) {
        try {
            fm.validateUrlParam(req["packetId"], "packetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v2/packets/${req["packetId"]}?${fm.renderURLSearchParams(req, ["packetId"])}`, { method: "DELETE" });
    },
    GetPacketsV3(fn, req) {
        return fn(`/forms-digital/v3/packets?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateCompanyAssets(fn, req) {
        return fn(`/forms-digital/v1/company-assets`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetFormDetails(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["formId"], "formId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/org/${req["orgId"]}/form/${req["formId"]}?${fm.renderURLSearchParams(req, ["orgId", "formId"])}`, { method: "GET" });
    },
    GetPacketDetails(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
            fm.validateUrlParam(req["packetId"], "packetId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/forms-digital/v1/org/${req["orgId"]}/packet/${req["packetId"]}?${fm.renderURLSearchParams(req, ["orgId", "packetId"])}`, { method: "GET" });
    },
    UpdateFormLocationAccess(fn, req) {
        return fn(`/forms-digital/v1/form-location-access`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdatePacketLocationAccess(fn, req) {
        return fn(`/forms-digital/v1/packet-location-access`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Update 'review_required' flag of the form.
     */
    UpdateFormReviewRequiredFlagV2(fn, req) {
        return fn(`/forms-digital/v2/forms/review-required`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Update 'review_required' flag of the packet.
     */
    UpdatePacketReviewRequiredFlagV2(fn, req) {
        return fn(`/forms-digital/v2/packets/review-required`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Update archive status for submissions - multi-location
     */
    UpdateSubmissionsArchiveStatusV2(fn, req) {
        return fn(`/forms-digital/v2/submissions-archive-status`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    IsValidSubmissionIdPersonIdCombination(fn, req) {
        return fn(`/forms-digital/v1/validate-submission-person-id?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Add COF for person
     */
    SetupPaymentMethod(fn, req) {
        return fn(`/forms-digital/v1/payment-method`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Lists existing payment methods for a person
     */
    GetPaymentMethods(fn, req) {
        return fn(`/forms-digital/v1/payment-methods?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateSubmissionsPatientData(fn, req) {
        return fn(`/forms-digital/v1/update-submissions-patient-data`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Insert ES Medical history forms
     */
    InsertESMedicalHistoryFormsV2(fn, req) {
        return fn(`/forms-digital/v2/es-medical-history-forms`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateDigitizationProcess(fn, req) {
        return fn(`/forms-digital/v1/digitization/process`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetSubmissionDetailsForPerson(fn, req) {
        return fn(`/forms-digital/v1/submissions/person?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    RetrieveDeletedForms(fn, req) {
        return fn(`/forms-digital/v1/retrieve-forms`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *INFO: This API is used to get the NP(New Patient) writeback status for a dentrix location.
     */
    GetNPWritebackStatus(fn, req) {
        return fn(`/forms-digital/v1/np-writeback-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     *INFO: This API is used to update the NP(New Patient) writeback status for a dentrix location.
     */
    UpdateNPWritebackStatus(fn, req) {
        return fn(`/forms-digital/v1/np-writeback-status`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
